import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { breakpoint: { type: Number, default: 640 } }
  #boundOnResize

  connect() {
    this.#activate(0)
    this.#boundOnResize = this.#onResize.bind(this)
    window.addEventListener("resize", this.#boundOnResize, { passive: true })
  }

  disconnect() {
    window.removeEventListener("resize", this.#boundOnResize)
    this.panelTargets.forEach(p => { p.hidden = false })
  }

  select(event) {
    this.#activate(this.tabTargets.indexOf(event.currentTarget))
  }

  // ── private ──────────────────────────────────────────────────

  #activate(index) {
    this.tabTargets.forEach((tab, i) => {
      tab.dataset.active = i === index
    })
    this.#applyVisibility(index)
  }

  #applyVisibility(index) {
    const isMobile = window.innerWidth < this.breakpointValue
    this.panelTargets.forEach((panel, i) => {
      panel.hidden = isMobile && i !== index
    })
  }

  #onResize() {
    const activeIndex = this.tabTargets.findIndex(t => t.dataset.active === "true")
    this.#applyVisibility(activeIndex >= 0 ? activeIndex : 0)
  }
}
